module.exports = __webpack_public_path__ + "img/soja.83df39af.svg";